import { PageId } from '~/shared/constants/pagesConstants'

// Ordered pages per section — used to compute how far the connecting line
// leading out of the current section should fill. Extend each array as more
// pages for that section get built.
export const SECTION_PAGE_IDS: Partial<Record<number, PageId[]>> = {
  1: [
    PageId.AGE_1,
    PageId.GENDER_1,
    PageId.BODY_PARTS_ANATOMY_V2_1,
    PageId.QUICK_EXPERIMENT_ANATOMY_V2_1,
    PageId.QL_MUSCLE_REVEAL_ANATOMY_V2_1,
  ],
  2: [
    PageId.SPOT_THE_FAKE_ANATOMY_V2_1,
    PageId.SPINE_POSTURE_ANATOMY_V2_1,
    PageId.WATER_DIGESTION_ANATOMY_V2_1,
    PageId.HIP_FLEXOR_ANATOMY_V2_1,
  ],
  3: [
    PageId.RATE_YOURSELF_ANATOMY_V2_1,
    PageId.STRONGEST_MUSCLE_ANATOMY_V2_1,
    PageId.SMALLEST_BONE_ANATOMY_V2_1,
    PageId.ORGAN_REGENERATES_ANATOMY_V2_1,
    PageId.POSTURE_INFLUENCE_ANATOMY_V2_1,
  ],
  4: [
    PageId.ANATOMY_NETWORK_ANATOMY_V2_1,
    PageId.LOWER_BACK_PAIN_ANATOMY_V2_1,
    PageId.NECK_STRAIN_ANATOMY_V2_1,
    PageId.SHOULDER_PAIN_ANATOMY_V2_1,
    PageId.VAGUS_NERVE_ANATOMY_V2_1,
  ],
  5: [
    PageId.DIAGNOSIS_HEADACHE_ANATOMY_V2_1,
    PageId.DIAGNOSIS_SHOULDER_ANATOMY_V2_1,
    PageId.DIAGNOSIS_HIP_ANATOMY_V2_1,
  ],
  6: [
    PageId.FOCUS_REVEAL_ANATOMY_V2_1,
    PageId.FOCUS_ABILITY_ANATOMY_V2_1,
    PageId.FOCUS_GOAL_ANATOMY_V2_1,
    PageId.DOOMSCROLLING_TIME_ANATOMY_V2_1,
    PageId.YOU_RE_NOT_ALONE_ANATOMY_V2_1,
    PageId.KIND_OF_LEARNING_ANATOMY_V2_1,
    PageId.SPECIFIC_REASON_ANATOMY_V2_1,
    PageId.SOCIAL_PROOF_ANATOMY_V2_1,
    PageId.DAILY_GOAL_ANATOMY_1,
    PageId.TOPICS_ANATOMY_1,
    PageId.EMAIL_1,
    PageId.PREPARE_PLAN_1,
    PageId.LEARNING_PROFILE_ANATOMY_V2_1,
    PageId.WHAT_WE_EXPLORED_ANATOMY_V2_1,
  ],
}
